import 'bootstrap/dist/css/bootstrap.min.css'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Toast from 'vue-toastification'
import "vue-toastification/dist/index.css"
import ccLoading from 'cc-loading'
import 'cc-loading/index.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'bootstrap-icons/font/bootstrap-icons.css'
import '@/css/main.css';
let app = createApp(App)
app.use(router)
app.use(Toast)
app.use(ccLoading)
app.mount('#app')
